import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

const headers = {};

const axiosInstance = axios.create({
    baseURL: '/api',
    timeout: 30000,
    headers,
});

export default axiosInstance;

export const axiosBaseQuery =
    (): BaseQueryFn<
        {
            url: string;
            timeout?: AxiosRequestConfig['timeout'];
            method?: AxiosRequestConfig['method'];
            body?: AxiosRequestConfig['data'];
            params?: AxiosRequestConfig['params'];
            headers?: Record<string, any>;
        },
        unknown,
        unknown
    > =>
    async ({
        url,
        method,
        body,
        params,
        timeout,
        headers,
    }): Promise<{
        data?: any;
        error?: {
            status: number | undefined;
            data: any;
        };
    }> => {
        try {
            const result = await axiosInstance({
                url,
                method,
                data: body,
                params,
                headers,
                timeout,
            });
            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError as AxiosError;
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            };
        }
    };
